import PropTypes from 'prop-types';
import React from 'react';
import analytics from '../../applicationServices/analytics/BookingAnalytics';


const onClick = (method, options) => () => {
  analytics[method](options);
};

const TrackClick = ({ children, method, options }) =>
  (
    <div
      role="presentation"
      onClick={onClick(method, options)}
    >
      {children}
    </div>
  ); // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions

TrackClick.propTypes = {
  children: PropTypes.node.isRequired,
  method: PropTypes.string.isRequired,
  options: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

TrackClick.defaultProps = {
  options: undefined,
};

export default TrackClick;




// WEBPACK FOOTER //
// ./src/app/hoc/Analytics/TrackClick.jsx